module.exports = __webpack_public_path__ + "static/media/doc.e95b139e.svg";